module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-x-5bd2a623.svg";